import React, {useState} from "react";
import assets from "../assets/imgs";

function MyPageCalendar({style}) {
  const [currentDate, setCurrentDate] = useState(new Date());

  const getMonthDays = (year, month) => {
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const daysInPrevMonth = new Date(year, month, 0).getDate(); // 이전 달의 마지막 날
    const lastDayOfMonth = new Date(year, month, daysInMonth).getDay(); // 마지막 날의 요일

    const days = [];
    // 이전 달의 빈 칸
    for (let i = firstDay - 1; i >= 0; i--) {
      days.push({ day: daysInPrevMonth - i, currentMonth: false });
    }
    // 현재 달의 날짜
    for (let i = 1; i <= daysInMonth; i++) {
      days.push({ day: i, currentMonth: true });
    }
    // 다음 달 날짜 채우기 (마지막 요일 기준으로 필요한 칸만 채움)
    for (let i = 1; i < 7 - lastDayOfMonth; i++) {
      days.push({ day: i, currentMonth: false });
    }

    return days;
  };

  const handlePrevMonth = () => {
    const prevMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    setCurrentDate(prevMonth);
  };

  const handleNextMonth = () => {
    const nextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
    setCurrentDate(nextMonth);
  };

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const days = getMonthDays(year, month);


  return (
    <div className="commonComponent" style={{...style, padding: "10px 23px"}}>
      {/* 상단 네비게이션 */}
      <div style={styles.calendarHead}>
        <button style={styles.calendarHeadButton} onClick={handlePrevMonth}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" style={{
              fill: "var(--grayscale-cool_50)" 
            }}>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0303 4.71967C13.3232 5.01256 13.3232 5.48744 13.0303 5.78033L8.56066 10.25L13.0303 14.7197C13.3232 15.0126 13.3232 15.4874 13.0303 15.7803C12.7374 16.0732 12.2626 16.0732 11.9697 15.7803L6.96967 10.7803C6.67678 10.4874 6.67678 10.0126 6.96967 9.71967L11.9697 4.71967C12.2626 4.42678 12.7374 4.42678 13.0303 4.71967Z"/>
          </svg>
        </button>
        <div style={styles.titleSection}>
          <img src={assets.icons.calendar} style={{width: "20px"}}/>
          <p style={styles.calendarTitle}>{year}.{String(month + 1).padStart(2, "0")}</p>
        </div>
        <button style={styles.calendarHeadButton} onClick={handleNextMonth}>
          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" style={{
              fill:"var(--grayscale-cool_50)"
            }}>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.96967 11.7803C0.676777 11.4874 0.676777 11.0126 0.96967 10.7197L5.43934 6.25L0.969669 1.78033C0.676776 1.48744 0.676776 1.01256 0.969669 0.719669C1.26256 0.426777 1.73744 0.426777 2.03033 0.719669L7.03033 5.71967C7.32322 6.01256 7.32322 6.48744 7.03033 6.78033L2.03033 11.7803C1.73744 12.0732 1.26256 12.0732 0.96967 11.7803Z"/>
          </svg>
        </button>
      </div>
      <div style={styles.divideLine}></div>
      {/* 요일 */}
      <div style={styles.calendarContents}>
        <div style={styles.calendarDay}>
          {["일", "월", "화", "수", "목", "금", "토"].map((day) => (
            <div key={day} className="font-body3-semibold" style={{...styles.dayName,
              color: day === "토" ? "#376DFF" : day === "일" ? "#FF6258" : "#676767"
            }}>
              {day}
            </div>
          ))}
          {/* {["월", "화", "수", "목", "금", "토", "일"].map((day) => (
            <div key={day} className="font-body3-semibold" style={styles.dayName}>
              {day}
            </div>
          ))} */}
        </div>
        {/* 날짜 */}
        <div style={styles.calendarDay}>
          {days.map((item, index) => (
            <div key={index}  style={{
              ...styles.dayName,
              height: "54px",
              ...(item.currentMonth ? {} : styles.falseDate),
            }} className="font-body2-semibold">
              {item.day}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const styles ={
  calendarHead:{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px",
    height: "60px",
    boxSizing: "border-box",
  },
  titleSection:{
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  calendarTitle:{
    fontWeight: "600",
    fontSize: "18px",
    lineHeight:"27px",
    color: "var(--text-color_90)"
  },
  calendarHeadButton:{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "28px",
    height: "28px",
    cursor: "pointer",
    borderRadius: "8px",
    border: "1px solid var(--grayscale-cool_40)",
    backgroundColor: "transparent"
  },
  divideLine:{
    height: "1px",
    width: "100%",
    backgroundColor : "var(--grayscale_30)",
  },
  calendarContents:{
    padding: "8px 20px 20px",
  },
  calendarDay:{
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    // gap: "5px",
    textAlign: "center",
  },
  dayName :{
    color: "var(--text-color_60)",
    width: "47px",
    height: "45px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  date:{

  },
  falseDate:{
    color: "var(--text-color_30)",
  },
  emptyDate: {
    backgroundColor: "transparent",
    color: "transparent",
    pointerEvents: "none",
  },
  

}
export default MyPageCalendar;